import { FormControl, FormControlLabel, FormGroup, FormLabel, Switch } from '@material-ui/core';
import { useField, useFormikContext } from 'formik';

function FormSwitch({ name, label, legend, ...otherProps }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = evt => {
    const { checked } = evt.target;
    setFieldValue(name, checked);
  };

  const SwitchProps = {
    ...field,
    ...otherProps,
    onChange: handleChange
  };

  const FormControlProps = {};
  if (meta && meta.touched && meta.error) FormControlProps.error = true;

  return (
    <>
      <FormControl {...FormControlProps}>
        <FormLabel component="legend" className="text-gray-700 font-semibold">
          {legend}
        </FormLabel>

        <FormGroup>
          <FormControlLabel control={<Switch {...SwitchProps} />} label={label} />
        </FormGroup>
      </FormControl>
    </>
  );
}

export default FormSwitch;
